import { date } from './date';
import { type } from './type';
import { message } from './message';

export const columns = [date, type, message];
